import React from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../Common/styles/table";
import { CustomStatusChip } from "../../Common/UI/StatusTag";

const statusMap: any = {
  live: { label: "Live", color: "#03543F", bgColor: "#DEF7EC" },
  not_live: { label: "Not Live", color: "#9B1C1C", bgColor: "#FDE8E8" },
  Locked: { label: "Locked", color: "text.primary", bgColor: "#F3F4F6" },
};
type Props = {
  data: any;
};

const StudyDetails = ({ data }: Props) => {
  return (
    <Box sx={{ p: 2, backgroundColor: "#fff", borderRadius: "10px" }}>
      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "16px",
          color: "text.primary",
          mb: 2.5,
        }}
      >
        Study Details
      </Typography>
      <Table sx={TableBorderRadiusTopLeftRight}>
        <TableHead>
          <TableRow>
            <StyledTableCell>Study Name</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 140 }}>
              Total Participants
            </StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>Start Date</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>Status</StyledTableCell>
            <StyledTableCell sx={{ minWidth: 100 }}>End Date</StyledTableCell>
          </TableRow>
        </TableHead>
        {data?.length > 0 && (
          <TableBody>
            {data?.map((row: any) => (
              <TableRow key={row?.id}>
                <StyledTableCell>{row?.studyName || "-"}</StyledTableCell>
                <StyledTableCell>{row?.participants ?? 0}</StyledTableCell>
                <StyledTableCell>{row?.startDate || "-"}</StyledTableCell>
                <StyledTableCell>
                  <CustomStatusChip
                    label={statusMap[row?.status]?.label}
                    color={statusMap[row?.status]?.color}
                    bgColor={statusMap?.[row?.status]?.bgColor}
                  />
                </StyledTableCell>
                <StyledTableCell>{row?.endDate || "-"}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      {data?.length === 0 && (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
    </Box>
  );
};

export default StudyDetails;
